var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { light: "" } },
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "blue-grey darken-3",
          attrs: { stateless: "", fixed: "", app: "", clipped: "", dark: "" },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c("img", { attrs: { src: "static/img/meteor_logo_wht.png" } }),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { expand: "" } },
            [
              _c("item-list", {
                attrs: {
                  items: _vm.$store.state.data.network,
                  title: "Network"
                },
                on: {
                  add: function($event) {
                    return _vm.handleAdd("network")
                  },
                  display: function($event) {
                    return _vm.handleDisplay("network", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c("item-list", {
                attrs: {
                  items: _vm.$store.state.data.station,
                  title: "Station"
                },
                on: {
                  add: function($event) {
                    return _vm.handleAdd("station")
                  },
                  display: function($event) {
                    return _vm.handleDisplay("station", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "blue-grey darken-3",
          attrs: {
            temporary: "",
            fixed: "",
            "hide-overlay": "",
            stateless: "",
            dark: ""
          },
          model: {
            value: _vm.stationDrawer,
            callback: function($$v) {
              _vm.stationDrawer = $$v
            },
            expression: "stationDrawer"
          }
        },
        [
          _vm.$store.state.stationNode != null
            ? [
                _c(
                  "v-toolbar",
                  { attrs: { dense: "", color: "blue-grey darken-4" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            _vm.stationDrawer = false
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("arrow_back")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-toolbar-title",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "" },
                            on: {
                              click: function($event) {
                                return _vm.handleDisplay(
                                  "station",
                                  _vm.$store.state.stationNode
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$store.state.stationNode.label) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "node-id" }, [
                              _vm._v(_vm._s(_vm.$store.state.stationNode.id))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list",
                  { attrs: { expand: "" } },
                  [
                    _c("item-list", {
                      attrs: {
                        items: _vm.$store.state.stationNode.location,
                        title: "Location"
                      },
                      on: {
                        add: function($event) {
                          return _vm.handleAdd("location")
                        },
                        display: function($event) {
                          return _vm.handleDisplay("location", $event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("item-list", {
                      attrs: {
                        items: _vm.$store.state.stationNode.channel_collection,
                        title: "Channel collection"
                      },
                      on: {
                        add: function($event) {
                          return _vm.handleAdd("channel_collection")
                        },
                        display: function($event) {
                          return _vm.handleDisplay("channel_collection", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          attrs: {
            color: "blue-grey darken-4",
            app: "",
            fixed: "",
            dense: "",
            dark: "",
            "clipped-left": ""
          }
        },
        [
          _c("v-toolbar-side-icon", {
            on: {
              click: function($event) {
                _vm.drawer = !_vm.drawer
              }
            }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            [
              _c(
                "label",
                {
                  staticClass: "v-btn v-btn--flat thene--dark",
                  style: { cursor: "pointer" },
                  attrs: { for: "uploader" }
                },
                [_vm._v("Load JSON")]
              ),
              _vm._v(" "),
              _c(
                "v-menu",
                { attrs: { "offset-y": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", flat: "" },
                      slot: "activator"
                    },
                    [_vm._v("Export")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    _vm._l(_vm.exportFormat, function(fmt, i) {
                      return _c(
                        "v-list-tile",
                        {
                          key: i,
                          on: {
                            click: function($event) {
                              return _vm.exportMetadata(fmt)
                            }
                          }
                        },
                        [_c("v-list-tile-title", [_vm._v(_vm._s(fmt))])],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        [
          _c(
            "v-container",
            { attrs: { fluid: "", "fill-height": "" } },
            [
              _c(
                "v-layout",
                { attrs: { "justify-center": "", "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { lg10: "" } },
                    [
                      _vm.$store.state.context == "display" &&
                      _vm.$store.state.nodeType == "channel_collection"
                        ? _c("display-channel-collection", {
                            attrs: {
                              "node-mapping": _vm.getNodeMapping(),
                              schema: _vm.$store.state.schema,
                              node: _vm.$store.state.node,
                              "plot-values": _vm.plotValues
                            },
                            on: {
                              clone: _vm.handleClone,
                              edit: _vm.handleEdit,
                              delete: _vm.handleDelete,
                              plotResponse: _vm.handlePlotResponse
                            }
                          })
                        : _vm.$store.state.context == "display" &&
                          _vm.$store.state.nodeType != "channel_collection"
                        ? _c("display-node", {
                            attrs: {
                              schema: _vm.$store.state.schema,
                              node: _vm.$store.state.node
                            },
                            on: {
                              edit: _vm.handleEdit,
                              delete: _vm.handleDelete
                            }
                          })
                        : (_vm.$store.state.context == "edit" ||
                            _vm.$store.state.context == "add") &&
                          _vm.$store.state.nodeType == "channel_collection"
                        ? _c("channel-form", {
                            attrs: {
                              schema: _vm.$store.state.schema,
                              devicesSchema:
                                _vm.$store.state.schemaCollection.devices,
                              deviceInventory: _vm.$store.state.deviceInventory,
                              softwareFilters: _vm.$store.state.softwareFilters
                            },
                            on: { submit: _vm.handleSubmit },
                            model: {
                              value: _vm.$store.state.values,
                              callback: function($$v) {
                                _vm.$set(_vm.$store.state, "values", $$v)
                              },
                              expression: "$store.state.values"
                            }
                          })
                        : (_vm.$store.state.context == "edit" ||
                            _vm.$store.state.context == "add") &&
                          _vm.$store.state.nodeType != "channel_collection"
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c("form-schema", {
                                    attrs: { schema: _vm.$store.state.schema },
                                    on: { submit: _vm.handleSubmit },
                                    model: {
                                      value: _vm.$store.state.values,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.$store.state,
                                          "values",
                                          $$v
                                        )
                                      },
                                      expression: "$store.state.values"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-card",
                            { staticClass: "ma-3" },
                            [
                              _c("v-card-title", [
                                _c("span", { staticClass: "headline" }, [
                                  _vm._v(
                                    "Ready to build your instrumental response !"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-card-text", [
                                _vm._v(
                                  "\n              The construction of your instrument response will be done in six steps:\n              "
                                ),
                                _c("ol", [
                                  _c("li", [
                                    _vm._v("define (add if not exists) the "),
                                    _c("strong", [_vm._v("network")]),
                                    _vm._v(" name and characteristics,")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("define the "),
                                    _c("strong", [_vm._v("station")]),
                                    _vm._v(" name and characteristics,")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("define the "),
                                    _c("strong", [_vm._v("location")]),
                                    _vm._v(" code,")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("define "),
                                    _c("strong", [_vm._v("channel")]),
                                    _vm._v(" characteristics, associate a "),
                                    _c("strong", [_vm._v("sensor")]),
                                    _vm._v(" and a "),
                                    _c("strong", [_vm._v("digitizer")]),
                                    _vm._v(", and "),
                                    _c("strong", [
                                      _vm._v("additional filters")
                                    ]),
                                    _vm._v(" if needed,")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("visualize")]),
                                    _vm._v(" the response graphically,")
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("export")]),
                                    _vm._v(" the response in "),
                                    _c("strong", [_vm._v("SEED dataless")]),
                                    _vm._v(", "),
                                    _c("strong", [_vm._v("StationXML")]),
                                    _vm._v(", or "),
                                    _c("strong", [_vm._v("JSON")]),
                                    _vm._v(
                                      " format (JSON will allow you to re-import your response in METEOR)."
                                    )
                                  ])
                                ])
                              ])
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-footer",
        { attrs: { app: "", fixed: "", dark: "", height: "auto" } },
        [
          _c(
            "v-card",
            { staticClass: "flex", attrs: { flat: "", tile: "" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "blue-grey darken-4 justify-end" },
                [
                  _c("span", { staticClass: "ml-5" }, [
                    _vm._v("METadata EditOR")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1 caption" }, [
                    _vm._v("(v2.0.0)")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        top: "",
                        left: "",
                        "max-width": "500",
                        "offset-y": "",
                        "close-on-content-click": false
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c("v-btn", _vm._g({ attrs: { flat: "" } }, on), [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "40px",
                                      position: "relative",
                                      top: "10px",
                                      left: "-5px"
                                    }
                                  },
                                  [_vm._v("“")]
                                ),
                                _vm._v("\n              CITE\n            ")
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.citeMenu,
                        callback: function($$v) {
                          _vm.citeMenu = $$v
                        },
                        expression: "citeMenu"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n              Jérôme Chèze, Christophe Maron, Diane Rivet, Fabrice Peix, Didier Brunel, Xavier Martin, Bertrand Delouis;\n              METEOR: Online Seismic Metadata Builder.\n              Seismological Research Letters 2020;; 92 (2A): 1141–1147.\n              doi: "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://doi.org/10.1785/0220200217"
                                }
                              },
                              [_vm._v("https://doi.org/10.1785/0220200217")]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-5",
                      attrs: {
                        flat: "",
                        href: "mailto:meteor@geoazur.unice.fr?subject=[METEOR]"
                      }
                    },
                    [_vm._v("CONTACT")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        attrs: { id: "uploader", type: "file", accept: ".json" },
        on: { change: _vm.loadJSON }
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "v-app-plugin-container" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-617ab0be", { render: render, staticRenderFns: staticRenderFns })
  }
}